export default __webpack_public_path__ + "static/media/Accompanying ill family member.de64855e.jpg";